import { type SelectOption } from '@factorialco/deprecated-design-system'
import range from 'lodash/range'

import i18n from 'modules/core/lib/i18n'

function carryOverExpiredOptions() {
  const values = [...range(1, 12), ...[12, 15, 18, 24, 36, 48, 60]]

  const expireInMonths = values.map<SelectOption>((i: number) => {
    return {
      label: i18n.tp('time_off.allowances.fields.expires.in_months', {
        count: i,
      }),
      value: i,
    }
  })

  return expireInMonths
}

export default carryOverExpiredOptions
